import { plugReportsConnectedStatus } from '../../utils/utils';

/** Status kind for StartMany embed map cluster rows (colors match list/card UI). */
export function getEmbedPortStatusKind(port, liveStatus) {
  if (
    liveStatus?.isOccupied ||
    liveStatus?.isInProgress ||
    port?.job?.state === 'IN_PROGRESS' ||
    port?.name?.includes('used')
  ) {
    return 'charging';
  }
  if (port?.name?.toLowerCase().includes('inservice')) {
    return 'inservice';
  }
  if (port?.online === false) {
    return 'offline';
  }
  if (liveStatus?.isReady && plugReportsConnectedStatus(port?.plugType)) {
    return 'ready';
  }
  return 'default';
}

export function getEmbedPortStatusClass(port, liveStatus) {
  return `embed-port-cluster__row--${getEmbedPortStatusKind(port, liveStatus)}`;
}
